import api from '@/libs/axios'

export default {
  async getList(params) {
    let response = await api.get('/admin/ai-positions', {
      params,
    })
    return response?.data?.data
  },

  async get(params) {
    let response = await api.get('/admin/ai-positions/detail', {
      params,
    })
    return response.data.data.document || null
  },

  async create(payload) {
    const response = await api.post('/admin/ai-positions', payload)
    return response || null
  },

  async update(payload) {
    const response = await api.put('/admin/ai-positions', payload)
    return response || null
  },

  async delete(payload) {
    const response = await api.delete('/admin/ai-positions', {
      data: payload,
    })
    return response
  },
}
